var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
      hover: "",
    },
    on: { "row-clicked": _vm.onClickRow },
    scopedSlots: _vm._u([
      {
        key: "cell(name)",
        fn: function (data) {
          return [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("h4", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(data.item.name)),
              ]),
            ]),
          ]
        },
      },
      {
        key: "cell(status)",
        fn: function (data) {
          return [
            data.item.shipper.is_active
              ? _c("b-badge", { attrs: { variant: "success" } }, [
                  _vm._v("Active"),
                ])
              : _c("b-badge", { attrs: { variant: "danger" } }, [
                  _vm._v("Inactive"),
                ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }